import React from "react";
import { useDepositWithdrawContext } from "src/contexts";
import { Loader, WithdrawalForm, PageLayout } from "src/components";
import { usePaymentsRoutes } from "src/hooks";

const WithdrawalPage: React.FC = (): JSX.Element => {
  const { widgetDataLoading, widgetDataError } = useDepositWithdrawContext();
  const { paymentsRoutes, paymentsRoutesLoading, paymentsRoutesError } = usePaymentsRoutes();

  if (widgetDataLoading || widgetDataError || paymentsRoutesLoading || paymentsRoutesError) {
    return <Loader />;
  }

  return (
    <PageLayout centered>
      <WithdrawalForm paymentsRoutes={paymentsRoutes} />
    </PageLayout>
  );
};

export default WithdrawalPage;
